export default import.meta.ROLLDOWN_FILE_URL_ELNkUmyWJv_pI_DshakVBg